var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SV',{staticClass:"tool",attrs:{"title":"Tools.工具箱"}},[_c('LAlert',{attrs:{"type":"info"}},[_vm._v("好像暂时没有工具呢...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }